import { render, staticRenderFns } from "./CageHis.vue?vue&type=template&id=2f5a6cf9&"
import script from "./CageHis.vue?vue&type=script&lang=js&"
export * from "./CageHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports